import { Link } from "react-router-dom";
import Slider from "react-slick";
import { useDatabase } from "../../hooks/useDatabase";

import { SkillList, SkillType } from "../SkillScroller/Skill";

import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import '../../helpers/overrides/slick.css';

import { BsArrowRight } from "react-icons/bs";

export default function Work({ isWorkListing = false }) {

    const db = useDatabase();

    const settings = {
        dots: true,
        arrows: true,
        infinite: false,
        speed: 500,
        slidesToShow: 2,
        slidesToScroll: 1,
        rows: 2,
        centerPadding: "20px",

        responsive: [
            {
                breakpoint: 900,
                settings: {
                    slidesToShow: 2,
                    rows: 1
                }
            },  {
                breakpoint: 750,
                settings: {
                    slidesToShow: 1,
                    rows: 1,
                    arrows: false
                }
            }
        ]
    };

    return (
        <section className="work-panel">
            <div className="inner">
                <h2>Work</h2>
                <p>Check out some of the projects I've been working on!</p>

                {isWorkListing === true ?
                <div className="cols span-2">
                    {db.sections.work.map(function (v, i) {
                        const tags: Array<keyof SkillType> = v.tags;

                        return <div className="col" key={v.id}>
                            <div className="work-item">
                                <img className="work-item-image" src={v.images[0].url} alt={v.images[0].alt} />
                                <div className="work-item-content">
                                    <div>
                                        <h3>{v.title}</h3>
                                        <div className="icon-list">
                                            {tags.map((tag) => {
                                                const skill = SkillList[tag];
                                                return skill ? (<div className="icon" key={tag}>{skill.component}</div>) : null;
                                            })}
                                        </div>
                                    </div>
                                    <Link to={"/work/" + v.handle} className="btn btn-outline">View <BsArrowRight size={20} /></Link>
                                </div>
                            </div>
                        </div>
                    })}
                </div> : 
                <Slider {...settings}>
                    {db.sections.work.map(function (v, i) {
                        const tags: Array<keyof SkillType> = v.tags;

                        return <div className="work-item" key={v.id}>
                            <img className="work-item-image" src={v.images[0].url} alt={v.images[0].alt} />
                            <div className="work-item-content">
                                <div>
                                    <h3>{v.title}</h3>
                                    <div className="icon-list">
                                        {tags.map((tag) => {
                                            const skill = SkillList[tag];
                                            return skill ? (<div className="icon" key={tag}>{skill.component}</div>) : null;
                                        })}
                                    </div>
                                </div>
                                <Link to={"/work/" + v.handle} className="btn btn-outline">View <BsArrowRight size={20} /></Link>
                            </div>
                        </div>;
                    })}
                </Slider>}

                {!isWorkListing ? <Link to="/work" className="btn btn-cta btn-icon">View all <BsArrowRight size={20} /></Link> : null}
            </div>
        </section>
    );
}
//https://react-slick.neostack.com/docs/example/multiple-rows